import { render, staticRenderFns } from "./changeBankCard.vue?vue&type=template&id=10edad72&scoped=true"
import script from "./changeBankCard.vue?vue&type=script&lang=js"
export * from "./changeBankCard.vue?vue&type=script&lang=js"
import style0 from "./changeBankCard.vue?vue&type=style&index=0&id=10edad72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10edad72",
  null
  
)

export default component.exports